// client/frontend-helpers/index.ts
export * from "./window-size.js";
